import { useInstance } from "@meraki-internal/react-dependency-injection";
import { useParams } from "react-router-dom";
import { useSubscription } from "@meraki-internal/state";
import { ClubHealthCard } from "./ClubHealthCard";
import { IonCard, IonCardContent, IonContent, IonPage } from "@ionic/react";
import { LightHeader } from "../HeaderAndNavigationBar";
import { ClubsState } from "./ClubsState";

export const EditClubHealthPage: React.FC = () => {
    let { clubId } = useParams();
    const clubs = useInstance(ClubsState);
    useSubscription(() => clubs);

    const club = clubs.maybeGetClub(clubId!);

    if (!club){
        return <h1>Loading...</h1>;
    }

    // TODO: loading
    return (
        <IonPage>
            <LightHeader title={`Edit ${club.name} Health `} />
                <IonContent>
                    <IonCard>
                        <IonCardContent>
                            <ClubHealthCard
                                // TODO: given I give it club, I no longer need to give it health
                                // or how to save
                                clubId={club.clubId}
                            />
                        </IonCardContent>
                    </IonCard>

                </IonContent>
        </IonPage>
    );
}